import apiClient from '../config/api';

const userService = {
  // Get all users for the current tenant
  getAllUsers: async () => {
    const response = await apiClient.get('/user');
    return response.data;
  },

  // Get a specific user by ID
  getUserById: async (id) => {
    const response = await apiClient.get(`/user/${id}`);
    return response.data;
  },

  // Create a new user
  createUser: async (userData) => {
    const response = await apiClient.post('/user', userData);
    return response.data;
  },

  // Update an existing user
  updateUser: async (id, userData) => {
    const response = await apiClient.post(`/user/update/${id}`, userData);
    return response.data;
  },

  // Delete a user (soft delete)
  deleteUser: async (id) => {
    const response = await apiClient.post(`/user/delete/${id}`);
    return response.data;
  },

  // Check if username is available
  checkUsername: async (username) => {
    const response = await apiClient.get(`/user/check-username/${username}`);
    return response.data;
  },

  // Check if tenant can create more users
  canCreateUser: async () => {
    const response = await apiClient.get('/user/can-create');
    return response.data;
  }
};

export default userService;





































































